// import React, { useContext } from 'react';
// import { Box, Select } from '@chakra-ui/react';
// import DepositContext from './DepositContext';

// const DepositFilter = () => {
//   const { filterStatus, setFilterStatus } = useContext(DepositContext);

//   return (
//     <Box mb={4}>
//       <Select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//         <option value="all">All</option>
//         <option value="pending">Pending</option>
//         <option value="approved">Approved</option>
//         <option value="rejected">Rejected</option>
//       </Select>
//     </Box>
//   );
// };

// export default DepositFilter;


import React, { useContext, useEffect } from 'react';
import { Box, Select } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate and useLocation
import DepositContext from './DepositContext';

const DepositFilter = () => {
  const { filterStatus, setFilterStatus } = useContext(DepositContext);
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get('status');

    if (statusParam) {
      setFilterStatus(statusParam);
    }
  }, [location.search, setFilterStatus]);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;

    navigate(`/dashboard/admin/deposit?status=${newStatus}`); // Use navigate instead of history.push

    setFilterStatus(newStatus);
  };

  return (
    <Box mb={4}>
      <Select value={filterStatus} onChange={handleStatusChange}>
        <option value="all">All</option>
        <option value="pending">Pending</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
      </Select>
    </Box>
  );
};

export default DepositFilter;
